import React from 'react';
import NavBar from './NavBar';
import SearchResultBar from './SearchResultBar';
import NavBarForNews from './NavBarForNews';
import MarketplaceBar from './MarketplaceBar';
import UserSection from './UserSection';
import Notification from './Notification';
import EnvironmentIndicator from './EnvironmentIndicator';
import WebIntlProvider from '../ui/i18n/WebIntlProvider';
import PropTypes from 'prop-types';

import AppConfigService from '../service/AppConfigService';
import AppService from '../service/AppService';
import AppConfig from '../domain/AppConfig';
const appConfig:AppConfig = AppService.appConfig();

export default class Header extends React.Component {

  static propTypes = {
    viewer: PropTypes.any,
    suggestSearch: PropTypes.any,
    disableSuggest: PropTypes.bool,
    disableCartBadge: PropTypes.bool,
    disableLogin: PropTypes.bool,
    disableNavBar: PropTypes.bool,
    disableNavCategory: PropTypes.bool,
    disableNavCatalog: PropTypes.bool,
    disableNavMarketplace: PropTypes.bool,
    disableNavNews: PropTypes.bool,
    disableNavExhibitions: PropTypes.bool,
    disableNavManufacturers: PropTypes.bool,
    disableNavShops: PropTypes.bool,
    disableNavPromote: PropTypes.bool,
    disableNavRegisterAccount: PropTypes.bool,
    disableMarketplaceBanner: PropTypes.bool,
    retry: PropTypes.func,
  };

  constructor(props) {
    super(props);

    this.ref = React.createRef();

    if (window.addEventListener) {
      window.addEventListener("message", ::this.onMessage, false);
    } else if (window.attachEvent) {
      window.attachEvent("onmessage", ::this.onMessage, false);
    }
  }

  onMessage(event) {
    if (event) {
      if (event.origin.includes('//id.')) {
        try {
          let data = JSON.parse(event.data);
          if (data.action === 'closeDialog' || data.action === 'close') {
            if (this.props.retry) {
              this.props.retry({
                force: true,
              });
            }
          }
        } catch (e) {
        }
        ;
      }
    }
  };

  render() {

    let {viewer, suggestSearch, disableNavBar, disableMarketplaceBanner} = this.props;

    let keyword = AppConfigService.getSearchKeyword();

    let style = {};
    // if (keyword) {
    //   style = {
    //     paddingBottom: '0px',
    //   }
    // }

    let showTopBar = AppConfigService.shouldShowMarketplaceTopBanner();
    let showLoginHeader = AppConfigService.shouldShowMarketplaceTopBanner();

    return (
      <WebIntlProvider>
        <React.Fragment>
          <EnvironmentIndicator />
          <div ref={this.ref}>
            {(!disableMarketplaceBanner || showTopBar) && <MarketplaceBar />}
            <div className="aperza-header" style={style}>
              <UserSection viewer={viewer} suggestSearch={suggestSearch} {...this.props} />
              {!disableNavBar && !keyword && <NavBar viewer={viewer}  {...this.props} />}
              {[AppConfig.APERZA_SEARCH,AppConfig.APERZA_EC].includes(appConfig.serviceType) && keyword && <SearchResultBar viewer={viewer} {...this.props} />}
            </div>
            {appConfig.serviceType==AppConfig.APERZA_NEWS && <NavBarForNews {...this.props} />}
            <Notification />
          </div>
        </React.Fragment>
      </WebIntlProvider>
    )
  }

}
